import { useLang } from "@/lib/lang";
import { useChatPrompts } from "@/hooks/queries";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ChatPromptChips({
  contextDocCount,
  streaming,
  onPrefill,
}) {
  const { t, lang } = useLang();
  const { data: chatPromptsData } = useChatPrompts(lang);

  const prompts = chatPromptsData?.prompts || [];

  const canUsePrompt = (prompt) => contextDocCount >= (prompt.min_docs || 0);

  const applyPrompt = (prompt) => {
    if (streaming) return;
    if (!canUsePrompt(prompt)) {
      if (prompt.min_docs > 0) {
        toast.error(t("task_need_docs").replace("{n}", String(prompt.min_docs)));
      }
      return;
    }
    onPrefill?.(prompt.prefill, {
      sendMode: prompt.send_mode || null,
      minDocs: prompt.min_docs || 0,
    });
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="chat-prompt-chips">
      {prompts.map((prompt) => (
        <Button
          key={prompt.key}
          type="button"
          data-testid={`prompt-${prompt.key}`}
          onClick={() => applyPrompt(prompt)}
          disabled={streaming || !canUsePrompt(prompt)}
          variant="outline"
          className="rounded-none h-8 text-[11px] border-slate-300 hover:bg-slate-900 hover:text-white"
        >
          {prompt.label}
        </Button>
      ))}
    </div>
  );
}
